import cn from "classnames";
import { ReactElement } from 'react';

import EyeCloseIcon from "assets/icons/eye-close.svg";
import EyeOpenIcon from "assets/icons/eye-open-black.svg";

import styles from "./show-hide-button.module.scss";

interface ShowHideButtonInterface {
  title?: string | ReactElement;
  onClick?: () => void;
  className?: string;
  isActive: boolean;
  isDisabled?: boolean;
  icon?: string;
  enabledIcon?: string;
  disabledIcon?: string;
}

const ShowHideButton = ({
  title,
  onClick,
  className,
  isActive,
  isDisabled,
  icon,
  enabledIcon,
  disabledIcon
}: ShowHideButtonInterface) => {
  return (
    <div
      className={cn(
        styles["show-hide-container"],
        { [styles["show-hide-container__disabled"]]: isDisabled },
        className
      )}
      onClick={onClick}
    >
      {icon && (
        <img
          src={icon}
          alt={`icon-${title}`}
          className={styles["show-hide__icon"]}
        />
      )}
      {title && <span className={styles["show-hide__title"]}>{title}</span>}
      <span className={styles["show-hide__icon"]}>
        <img
          src={
            isActive ? enabledIcon ?? EyeOpenIcon : disabledIcon ?? EyeCloseIcon
          }
          alt={`button ${isActive ? "active" : "hidden"}`}
        />
      </span>
    </div>
  );
};

export default ShowHideButton;
